import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { IDepartmentViewModel } from 'viewModels';
import { useQuery } from 'react-query';
import { CompanyController } from '../controller/CompanyController';
import { useAuth } from './auth';
import { TypeUser } from '../types/enums';

type ProfileContextProps = {
  children: ReactNode;
};
interface IInitialValues {
  departments: IDepartmentViewModel[];
  setDepartments: React.Dispatch<React.SetStateAction<IDepartmentViewModel[]>>;
  isFetchingDepartments: boolean;
}
const ProfileContext = React.createContext({} as IInitialValues);

const ProfileContextProvider = ({ children }: ProfileContextProps) => {
  const { user, tokenIsValid } = useAuth();
  const [departments, setDepartments] = useState<IDepartmentViewModel[]>([]);
  const [isFetchingDepartments, setIsFetchingDepartments] = useState(false);
  const { isFetching } = useQuery(
    'departments',
    () => CompanyController.getAllDepartments(user.id),
    {
      onSuccess: (data) => {
        setDepartments(data);
      },
      refetchOnWindowFocus: false,
      enabled: !!user.id && tokenIsValid && [TypeUser.COMPANY, TypeUser.ADM].includes(user.type),
    },
  );

  useEffect(() => {
    if (!tokenIsValid) {
      setDepartments([]);
      setIsFetchingDepartments(false);
    }
  }, [tokenIsValid]);

  useEffect(() => {
    setIsFetchingDepartments(isFetching);
  }, [isFetching]);

  const contextValues = useMemo(
    () => ({ departments, setDepartments, isFetchingDepartments }),
    [departments, isFetchingDepartments],
  );
  return <ProfileContext.Provider value={contextValues}>{children}</ProfileContext.Provider>;
};
export const useDepartments = () => useContext(ProfileContext);
export default ProfileContextProvider;
